// ACTIVE PORT CALLS SORT BY

export const SCHEDULED_DEPARTURE = 'SCHEDULED_DEPARTURE'

// ACTIVE PORT CALLS FILTER BY

export const SHOW_ALL = 'SHOW_ALL'
export const SHOW_PINNED_SHIPS = 'PINNED_SHIPS'
export const SHOW_PINNED_PORTS = 'PINNED_PORTS'
